// extracted by mini-css-extract-plugin
export default {"w-full":"Customers_w-full__i37EJ","row":"Customers_row__SouQX","col":"Customers_col__P4gnd","card":"Customers_card__-+PQ6"};